import React, { ReactNode } from "react";
import { Modal } from "react-bootstrap";

interface ModalProps {
  id: string;
  title: string;
  children?: ReactNode;
  footer?: ReactNode;
  size?: "sm" | "lg" | "xl";
  show?: boolean;
  onHide?: () => void;
  pendingSubmitting?: boolean;
  centered?: boolean;
  backdrop?: "static" | true | false;
  keyboard?: boolean;
}

const Reason: React.FC<ModalProps> = ({
  id,
  title,
  children,
  footer,
  size,
  show = false,
  onHide,
  pendingSubmitting = false,
  centered = true,
  backdrop = "static",
  keyboard = false,
}) => {
  const dialogClass = size ? `modal-${size}` : "";

  return (
    <Modal
      id={id}
      show={show}
      onHide={onHide}
      centered={centered}
      backdrop={backdrop}
      keyboard={keyboard}
      dialogClassName={dialogClass}
    >
      <Modal.Header>
        <Modal.Title id={`${id}Label`}>{title}</Modal.Title>

        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
          disabled={pendingSubmitting}
        />
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default Reason;
